import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Logo } from '../Logo';
import { Link } from '../Link';
import { LegalDialog } from './LegalDialog';
import { useMobile } from 'src/hooks/useMobile';

const sx = {
  rowGroup: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
};

export function Footer() {
  const theme = useTheme();
  const isMobile = useMobile();

  return (
    <footer>
      <Box
        sx={{
          background: 'rgba(0, 14, 33, 0.8)',
          backdropFilter: 'blur(50px)',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          borderTop: `1px solid ${theme.palette.primary.dark}`,
          padding: {
            xl: '15px 120px',
            lg: '15px 60px',
            md: '30px 30px',
            sm: 3,
            xs: 3,
          },
          marginTop: '60px',
        }}
      >
        {!isMobile ? (
          <>
            <Box sx={sx.rowGroup}>
              <Logo width={36} height={36} asLink />
              <Typography
                variant="h6"
                sx={{ color: theme.palette.text.primary, mx: 2 }}
              >
                BluMint
              </Typography>
              <Typography color="text.primary" sx={{ mx: 2 }}>
                Own Your Game
              </Typography>
            </Box>
            <Box
              sx={{
                ...sx.rowGroup,
                mx: 1,
              }}
            >
              <Link
                href={{
                  pathname: '/',
                  query: { legal: 'terms' },
                }}
                shallow={true}
                sx={{
                  color: theme.palette.text.secondary,
                  textDecorationColor: theme.palette.text.secondary,
                  mx: 4,
                }}
              >
                Terms & Conditions
              </Link>
              <Link
                href={{
                  pathname: '/',
                  query: { legal: 'privacy' },
                }}
                shallow={true}
                sx={{
                  color: theme.palette.text.secondary,
                  textDecorationColor: theme.palette.text.secondary,
                  mx: 4,
                }}
              >
                Privacy Policy
              </Link>
              <Link
                href={{
                  pathname: '/',
                  query: { legal: 'copyright' },
                }}
                shallow={true}
                sx={{
                  color: theme.palette.text.primary,
                  textDecorationColor: theme.palette.text.primary,
                  ml: 4,
                  mr: 1,
                }}
              >
                Copyright
              </Link>{' '}
              © 2022 BluMint Inc. All rights reserved.
            </Box>
          </>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              width: '100%',
            }}
          >
            {/* LOGO + TAGLINE */}
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  pt: 2,
                  pr: 2,
                }}
              >
                <Logo width={40} height={40} asLink />
              </Box>
              <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <Typography sx={{ fontWeight: 600, fontSize: 16 }}>
                  BluMint
                </Typography>
                <Typography>Own Your Game</Typography>
              </Box>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                justifyContent: 'center',
              }}
            >
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <Link
                  href={{
                    pathname: '/',
                    query: { legal: 'copyright' },
                  }}
                  shallow={true}
                  sx={{
                    color: theme.palette.text.primary,
                    textDecoration: 'none',
                  }}
                >
                  <span style={{ textDecoration: 'underline' }}>Copyright</span>{' '}
                  © 2022 BluMint Inc. All rights reserved.
                </Link>
              </Box>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                }}
              >
                <Link
                  href={{
                    pathname: '/',
                    query: { legal: 'terms' },
                  }}
                  shallow={true}
                  sx={{
                    color: theme.palette.text.secondary,
                    textDecorationColor: theme.palette.text.secondary,
                    mx: 4,
                  }}
                >
                  Terms & Conditions
                </Link>
                <Link
                  href={{
                    pathname: '/',
                    query: { legal: 'privacy' },
                  }}
                  shallow={true}
                  sx={{
                    color: theme.palette.text.secondary,
                    textDecorationColor: theme.palette.text.secondary,
                  }}
                >
                  Privacy Policy
                </Link>
              </Box>
            </Box>
          </Box>
        )}
      </Box>
      <LegalDialog />
    </footer>
  );
}
